import axios from 'axios';

export const fetchRoles = async (currentPage, rowPerPage, searchKeywords) => {
  let response;
  var data = {
    CurrentPage: currentPage,
    RowPerPage: rowPerPage,
    SearchKeywords: searchKeywords,
  }
  try {
    response = await axios.post(`/api/Role/GetRoleList`, data);

    if (response && response.status === 200) {
      return response.data;
    } else {
      console.error("GetUser Error:")
      return response.status;
    }
  } catch (error) {
    if (error.response.status === 401) {
      return error.response.status;
    }
  }
}

export const fetchRole = async (id) => {
  try {
    const response = await axios.post(`/api/Role/GetRoleById`, { id: id });

    if (response && response.status === 200) {
      return response.data;
    } else {
      return response.status;
    }
  } catch (error) {
    if (error.response.status === 401) {
      return error.response.status;
    } else {
      let exceptionData = { expmessage: error.response.data.title, expstring: true }
      return exceptionData;
    }
  }
}

export const saveRole = async (values,MEfilterLists) => {
  const data = {
    RoleName: values.roleName,
    Active: values.active,
    RoleFeatures: values.filterRoleFeatures,
  }
  var response;
  if (values.roleId === "" || values.roleId === null || values.roleId === undefined) {
    response = axios.post('/api/Role/CreateRole', data)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return error;
      });
  }
  else {
    data.RoleId = parseInt(values.roleId);
    data.RoleFeatures = values.roleFeatures;
    data.CreatedBy = values.createdBy;
    data.CreatedDate = values.createdDate;
    data.FilterMGList = MEfilterLists;

    response = axios.post('/api/Role/UpdateRole', data)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return error;
      });
  }
  return response;
};

export const deleteRole = async (roleId, roleName,roleFeatures) => {
  const data = {
    RoleName: roleName,
    RoleId: roleId,
    RoleFeatures: roleFeatures,
  }
  try {
    const response = await axios.post('/api/Role/DeleteRole', data);

    if (response && response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }
};

